import React, { useState, useEffect, useCallback } from "react";
import NavigationSidebar from "../components/Navigationsidebar/NavigationSidebar";
import Header from "../components/Header";
import BarChartViz01 from "../components/Dashboardviz/D13/Viz01";
import BarChartViz02 from "../components/Dashboardviz/D13/Viz02";
import BarChartViz03 from "../components/Dashboardviz/D13/Viz03";
import BarChartViz04 from "../components/Dashboardviz/D13/Viz04";
import FilterSidebar from "../components/FilterSidebar/FilterSidebar";
import { useFilter } from "../FilterContext";
import { FILTER_CONFIG } from "../config/filterconfig"; // Import the filter configuration
import jsonData from "../current-survey-numeric.json"; // Ensure the path is correct
import "./D13_Survey_Specific_Questions.css"; // Import the CSS file

const D13_Survey_Specific_QuestionsDashboard = () => {
  const { filterCriteria, setFilterCriteria } = useFilter();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Default state is now closed
  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);
  const [filterData, setFilterData] = useState({});

  // Dynamically populate filter options using FILTER_CONFIG
  useEffect(() => {
    const sortAlphabetically = (array) =>
      array.filter(Boolean).sort((a, b) => a.localeCompare(b));

    const generateFilterOptions = () => {
      const options = {};
      FILTER_CONFIG.forEach(({ fieldName, jsonKey, sortOrder }) => {
        let uniqueValues = [...new Set(jsonData.map((item) => item[jsonKey]))];
        uniqueValues = uniqueValues.filter((value) => value !== null);

        if (sortOrder) {
          uniqueValues = uniqueValues.sort(
            (a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b)
          );
        } else {
          uniqueValues = sortAlphabetically(uniqueValues);
        }

        options[fieldName] = uniqueValues;
      });

      return options;
    };

    setFilterData(generateFilterOptions());
  }, []);

  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen((prevState) => !prevState);
  }, []);

  const toggleFilterSidebar = useCallback(() => {
    setIsFilterSidebarOpen((prevState) => !prevState);
  }, []);

  // Update refresh function to use window.location.reload()
  const refreshPage = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <div className="D13_Survey_Specific_Questions-dashboard-container">
      <Header
        title="Survey Specific Questions Dashboard"
        toggleSidebar={toggleSidebar}
        refreshPage={refreshPage}
        toggleFilterSidebar={toggleFilterSidebar}
      />
      <NavigationSidebar
        className={
          isSidebarOpen
            ? "D13_Survey_Specific_Questions-sidebar-open"
            : "D13_Survey_Specific_Questions-sidebar-closed"
        }
        isOpen={isSidebarOpen}
      />
      <FilterSidebar
        className={
          isFilterSidebarOpen
            ? "D13_Survey_Specific_Questions-filter-sidebar-open"
            : "D13_Survey_Specific_Questions-filter-sidebar-closed"
        }
        isOpen={isFilterSidebarOpen}
        filterCriteria={filterCriteria}
        filterOptions={filterData}
        setFilterCriteria={setFilterCriteria}
      />
      <div className="D13_Survey_Specific_Questions-main-content">
        <div className="D13_Survey_Specific_Questions-charts-container">
          <div className="D13_Survey_Specific_Questions-chart">
            <h2 className="ccidemographics-card-header">
              Incentive Motivation
            </h2>
            <h5>The incentive/bonus program motivates me.</h5>
            <BarChartViz01 filterCriteria={filterCriteria} />
          </div>
          <div className="D13_Survey_Specific_Questions-chart">
            <h2 className="ccidemographics-card-header">
              Incentive Satisfaction
            </h2>
            <h5>I am satisfied with my incentive bonus program.</h5>
            <BarChartViz02 filterCriteria={filterCriteria} />
          </div>
          <div className="D13_Survey_Specific_Questions-chart">
            <h2 className="ccidemographics-card-header">Best Friend</h2>
            <h5>I have a best friend at work.</h5>
            <BarChartViz03 filterCriteria={filterCriteria} />
          </div>
          <div className="D13_Survey_Specific_Questions-chart">
            <h2 className="ccidemographics-card-header">
              Personal Connections
            </h2>
            <h5>
              I have built strong personal connections or relationships with my
              colleagues.
            </h5>
            <BarChartViz04 filterCriteria={filterCriteria} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default D13_Survey_Specific_QuestionsDashboard;